import reduxFetch from 'react-redux-fetch';
import apiRoutes from '../../../../app/api/routes';
import { UPDATE_COMMUNITY_ROLE_RESOURCE, COMMUNITY_ROLES_RESOURCE } from '../../constants';
import { createErrorMessage } from '../../../app/helpers/createErrorMessage';

export default ComposedComponent =>
  reduxFetch([
    {
      resource: UPDATE_COMMUNITY_ROLE_RESOURCE,
      method: 'put',
      request: (communityId, organisationRoleTag, body, callback, t) => ({
        body,
        url: apiRoutes.communityRoles2(communityId, organisationRoleTag),
        meta: {
          callback,
          updateOtherList: {
            resource: COMMUNITY_ROLES_RESOURCE,
            listPath: 'communityRoles',
            idProp: 'tag',
            id: organisationRoleTag,
            valuesModifier: values => ({ ...values, ...body, alias: body.alias || '' }),
          },
          toaster: {
            onSuccessMessage: t('updateCommunityRoleSuccess'),
            onErrorMessage: createErrorMessage(t, 'updateCommunityRoleFailed'),
          },
        },
      }),
    },
  ])(ComposedComponent);
